import { useQuery } from '@tanstack/react-query';
import { dueCardsQueryOptions } from '../lib/queries';

export function useDueCards(isAuthenticated: boolean) {
  const { data: dueCards = [], isLoading } = useQuery({
    ...dueCardsQueryOptions(),
    enabled: isAuthenticated,
  });

  return { dueCards, dueCount: dueCards.length, isLoading };
}
